import EditablePropsType from '../../../types/composer';
import titleSchema from './title';
import { faHeadSideBrain } from '@fortawesome/pro-solid-svg-icons/faHeadSideBrain';
import { faHexagonCheck } from '@fortawesome/pro-solid-svg-icons/faHexagonCheck';
import { faVideo } from '@fortawesome/pro-solid-svg-icons/faVideo';
import { faAtomSimple } from '@fortawesome/pro-solid-svg-icons/faAtomSimple';
import { faGaugeMax } from '@fortawesome/pro-regular-svg-icons/faGaugeMax';

const iconSchema = {
  label: 'Icon',
  name: 'icon',
  type: EditablePropsType.Select,
  selectOptions: {
    options: [
      { label: '', value: '' },
      { label: 'Gauge max', value: 'gauge-max', iconComponent: faGaugeMax },
      { label: 'Video', value: 'video', iconComponent: faVideo },
      {
        label: 'Hexagon check',
        value: 'hexagon-check',
        iconComponent: faHexagonCheck,
      },
      {
        label: 'Atom simple',
        value: 'atom-simple',
        iconComponent: faAtomSimple,
      },
      {
        label: 'Head side brain',
        value: 'head-side-brain',
        iconComponent: faHeadSideBrain,
      },
    ],
  },
};

const imageSchema = {
  type: EditablePropsType.Object,
  label: 'Image',
  name: 'image',
  properties: {
    image: {
      type: EditablePropsType.Media,
      name: 'image',
      label: 'Image Source',
      accept: ['image/*'],
      required: true,
    },
    altText: {
      type: EditablePropsType.Text,
      name: 'altText',
      label: 'Alt Text',
      required: true,
    },
  },
};

export const tabsSchema = {
  label: 'Tabs',
  name: 'tabs',
  type: EditablePropsType.Array,
  items: {
    label: 'Tab',
    name: 'tab',
    type: EditablePropsType.Object,
    properties: {
      tabName: {
        label: 'Tab Name',
        name: 'tabName',
        type: EditablePropsType.Text,
      },
      tabContent: {
        label: 'Tab Content',
        name: 'tabContent',
        type: EditablePropsType.Object,
        properties: {
          mainDefinition: {
            label: 'Main Definition',
            name: 'mainDefinition',
            type: EditablePropsType.Object,
            properties: {
              title: titleSchema,
              icon: iconSchema,
              description: {
                type: EditablePropsType.Text,
                label: 'Subtitle',
                name: 'description',
              },
            },
          },
          image: imageSchema,
          illustrationPosition: {
            label: 'Illustration Position',
            name: 'illustrationPosition',
            type: EditablePropsType.Select,
            selectOptions: {
              options: [
                { label: 'Right', value: 'right' },
                { label: 'Left', value: 'left' },
              ],
            },
          },
          features: {
            label: 'Features',
            name: 'features',
            type: EditablePropsType.Array,
            items: {
              label: 'Feature',
              name: 'feature',
              type: EditablePropsType.Object,
              properties: {
                text: {
                  label: 'Text',
                  name: 'text',
                  type: EditablePropsType.Text,
                },
                icon: iconSchema,
              },
            },
          },
        },
      },
    },
  },
};
